<template>
  <div  class="detail-container" v-html="content">
    
  </div>
  
</template>

<script>
export default {
  data () {
    return {
      content:'',
      id:0
    }
  },
  methods: {
    getRuleDetail(){
      const params = new URLSearchParams()
      params.append('id', this.id)
      
      this.$axios.post(this.$axios.defaults.baseUrl+'/app/ypjarticlever2/loadarticlecontent',params).then(
            res=>{
              if(res.status=='200'){//http 请求状态
                if(res.data){//判断是否有返回值
                  console.log(res.data)
                  if(res.data.code==1 && res.data.result){//业务正常
                    if(res.data.result.detail){
                      this.content=res.data.result.detail.content
                    }
                    
                  }else{//业务上的错误提示
                    this.$message.error(res.data.msg)
                  }
                  
                }else{//没有返回值
                  
                  this.$message.error('网络开小差了，请稍后再试！')
                }
                
              }else{
                this.$message.error('网络开小差了，请稍后再试！');
              }
            },error=>{
              this.$message.error('网络开小差了，请稍后再试！');
            }
          )

    }
    
  },
  mounted(){
    this.id=this.$route.params.id
    this.getRuleDetail()
  }
}
</script>
<style scoped>
.detail-container {
    padding: 15px 15px;
    background-color: #fff;
    height: 100%;
    overflow: auto;
    color: #333;
}
</style>




// WEBPACK FOOTER //
// src/components/Rule.vue